import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CurrentUser, publicView } from '@models/Core/CurrentUser';
import { User } from '@models/Core/User';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AssetsPipe } from '@pipes/assets.pipe';
import { AuthenticationService } from '@services/auth/authentication.service';
import { ConfigService } from '@services/config.service';
import { UsersService } from '@services/users/users.service';
import { combineLatest, iif, of } from 'rxjs';

import { DirectMsgComponent } from '../../direct-msg/direct-msg.component';

@Component({
  selector: 'app-profile-view',
  templateUrl: './view.component.html',
  styleUrls: ['./view.component.scss'],
})
export class ProfileViewComponent implements OnInit {
  @Input() user: User;
  // user: User;
  currentUser: CurrentUser;

  constructor(
    private activatedRoute: ActivatedRoute,
    private auth: AuthenticationService,
    private users: UsersService,
    private appConfig: ConfigService,
    private modalService: NgbModal,
    private assetsPipe: AssetsPipe,
  ) {}

  ngOnInit() {
    if (!this.user) {
      combineLatest(
        this.activatedRoute.params,
        this.auth.getCurrentUser,
        this.activatedRoute.queryParams,
      ).subscribe(([params, curruser, queryParams]) => {
        this.currentUser = curruser;

        iif(
          () => curruser._id !== params.id,
          this.users.get(params.id),
          of(publicView(curruser)),
        ).subscribe(user => {
          this.user = user;

          if (queryParams.dm) {
            this.openDirectMsg();
          }
        });
      });
    }
  }

  get profilePicUrl() {
    const _default = 'image/default_profile_picture.png';
    return this.assetsPipe.transform(
      this.user ? this.user.profile_picture || _default : _default,
    );
  }

  get hasContactInfo() {
    return this.user && (this.user.email || this.hasLocation);
  }

  get hasLocation() {
    return (
      this.user &&
      this.user.location &&
      (this.user.location.city ||
        this.user.location.country ||
        this.user.location.zipcode)
    );
  }

  openDirectMsg() {
    const ref = this.modalService.open(DirectMsgComponent);
    ref.componentInstance.user = this.user;
  }
}
